<div class="loader-div">
    <div class="panel-body tabbed-panel">
        <div class="col-12">
            <div class="row mt-4">
                <div class="col-md-12">
                    <div class="txt-loading txt-xl mb-2"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="txt-loading txt-xl mb-2"></div>
                    <div class="txt-loading txt-xl mb-2"></div>
                    <div class="txt-loading txt-xl mb-2"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="txt-loading  txt-xl mb-2"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="txt-loading  txt-xl mb-2"></div>
                </div>
            </div>
        </div>
    </div>
</div>